import React, { Component } from "react";
import { BiArrowBack } from "react-icons/bi";
import ProgressiveImage from "react-progressive-image";
import { connect } from "react-redux";
import ContentLoader from "react-content-loader";
import { IMAGE_BASE_URL } from "../../../api";
import { IoMdSend } from "react-icons/io";
import {
    getTeacherSingleChatView,
    sendTeacherChat,
    clearTeacherSingleChat,
} from "../../../redux/Teacher/chat/action";
import Moment from "react-moment";
import teacher from "../../../assets/Images/bg.png";
import { RiMessage3Fill } from "react-icons/ri";

class SingleTeacherChat extends Component {
    state = {
        loading: true,
        message: "",
        chats: [],
    };

    chatEndRef = React.createRef();

    onHandleBack = () => {
        this.props.history.goBack();
    };

    componentDidMount() {
        if (this.props.clearTeacherSingleChat) {
            this.props.clearTeacherSingleChat();
        }
        this.setState({ loading: true, chats: [] });
        this.__getChats();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.chats.length !== this.state.chats.length) {
            this.scrollToBottom();
        }
    }

    scrollToBottom = () => {
        if (this.chatEndRef && this.chatEndRef.current) {
            this.chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    __getChats = () => {
        const { user } = this.props;
        const parentId = this.props.match?.params?.parent_id;
        const teacherId = this.props.match?.params?.teacher_id;
        const token = user?.data?.auth_token;

        if (token && parentId && teacherId) {
            this.props.getTeacherSingleChatView(token, parentId, teacherId)
                .then(() => {
                    this.setState({ loading: false });
                })
                .catch(() => {
                    this.setState({ loading: false });
                });
        }
    };

    handleMessageInput = (e) => {
        this.setState({
            message: e.target.value,
        });
    };

    __sendChat = () => {
        const { user, chats } = this.props;
        const parentId = this.props.match?.params?.parent_id;
        const teacherId = this.props.match?.params?.teacher_id;
        const convoId = chats?.convo_id || 0;
        const token = user?.data?.auth_token;

        if (this.state.message?.trim().length > 0) {
            const msgText = this.state.message.trim();
            this.setState({ message: "" });

            this.props.sendTeacherChat(
                token,
                parentId,
                teacherId,
                convoId,
                msgText
            );

            setTimeout(() => {
                this.props.getTeacherSingleChatView(token, parentId, teacherId);
            }, 300);
        }
    };

    static getDerivedStateFromProps(props, state) {
        const currentParentId = props.match?.params?.parent_id;
        if (
            props.chats &&
            props.chats.user &&
            String(props.chats.user.id) === String(currentParentId) &&
            props.chats.conversations &&
            props.chats.conversations.data
        ) {
            return {
                chats: props.chats.conversations.data,
                loading: false,
            };
        }
        return null;
    }

    render() {
        const { chats: rawChats, user } = this.props;
        const currentParentId = this.props.match?.params?.parent_id;

        const isCurrentChatLoaded =
            rawChats &&
            rawChats.user &&
            String(rawChats.user.id) === String(currentParentId);

        if (this.state.loading || !isCurrentChatLoaded) {
            return (
                <React.Fragment>
                    <div className="name-bar d-flex flex-row justify-content-between align-items-center w-100 px-3 py-4 border-bottom">
                        <div className="d-flex flex-row align-items-center gap-2" onClick={() => this.onHandleBack()} style={{ cursor: "pointer" }}>
                            <BiArrowBack style={{ fontSize: "1.2rem", color: "#c1486f" }} />
                            <span className="ms-2 fw-bold text-muted" style={{ fontSize: "15px" }}>Loading Chat...</span>
                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "70vh" }}>
                        <ContentLoader
                            viewBox="0 0 380 400"
                            backgroundColor="#F3F3F3"
                            foregroundColor="#FFFFFF"
                            width={320}
                            height={350}
                        >
                            <rect x="20" y="20" rx="15" ry="15" width="220" height="40" />
                            <rect x="140" y="80" rx="15" ry="15" width="220" height="40" />
                            <rect x="20" y="140" rx="15" ry="15" width="220" height="40" />
                            <rect x="140" y="200" rx="15" ry="15" width="220" height="40" />
                            <rect x="20" y="260" rx="15" ry="15" width="220" height="40" />
                        </ContentLoader>
                        <div className="text-muted mt-2" style={{ fontSize: "13px" }}>Loading messages...</div>
                    </div>
                </React.Fragment>
            );
        }

        const chatUser = rawChats?.user;
        const messages = this.state.chats || [];

        return (
            <React.Fragment>
                {/* Header */}
                <div className="name-bar d-flex flex-row justify-content-between align-items-center w-100 px-3 py-3 border-bottom shadow-sm bg-white sticky-top">
                    <div className="d-flex flex-row align-items-center gap-2">
                        <div onClick={() => this.onHandleBack()} style={{ cursor: "pointer" }}>
                            <BiArrowBack style={{ fontSize: "1.3rem", color: "#c1486f" }} />
                        </div>
                        <ProgressiveImage
                            delay={20}
                            src={IMAGE_BASE_URL + chatUser?.image}
                            placeholder={teacher}
                        >
                            {(src) => (
                                <img
                                    src={src}
                                    style={{
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        border: "2px solid #c1486f",
                                    }}
                                    alt={chatUser?.name || "User"}
                                />
                            )}
                        </ProgressiveImage>
                        <div className="d-flex flex-column ms-1">
                            <span className="fw-bold" style={{ fontSize: "15px", color: "#212529" }}>
                                {chatUser?.name}
                            </span>
                            {chatUser?.email && (
                                <span className="text-muted" style={{ fontSize: "11px" }}>
                                    {chatUser.email}
                                </span>
                            )}
                        </div>
                    </div>
                </div>

                {/* Messages List */}
                <div style={{ paddingBottom: "90px", paddingTop: "10px", minHeight: "75vh" }}>
                    {messages.length > 0 ? (
                        messages.map((message, index) => {
                            const isSentByMe = Boolean(
                                message.is_sender === 1 ||
                                message.is_sender === true ||
                                (message.sender && (
                                    String(message.sender.id) === String(user?.data?.staff?.id) ||
                                    String(message.sender.id) === String(user?.data?.id) ||
                                    String(message.user_id) === String(user?.data?.id)
                                ))
                            );

                            return (
                                <div
                                    key={message.id || index}
                                    className={`d-flex flex-column px-3 pt-2 ${isSentByMe ? "align-items-end" : "align-items-start"}`}
                                >
                                    <div
                                        style={{
                                            backgroundColor: isSentByMe ? "#c1486f" : "#E9ECEF",
                                            color: isSentByMe ? "#FFFFFF" : "#212529",
                                            borderRadius: isSentByMe ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
                                            padding: "10px 14px",
                                            fontSize: "14px",
                                            lineHeight: "1.45",
                                            maxWidth: "78%",
                                            wordBreak: "break-word",
                                            boxShadow: isSentByMe ? "0 2px 6px rgba(193, 72, 111, 0.25)" : "0 1px 3px rgba(0,0,0,0.06)"
                                        }}
                                    >
                                        {message.body}
                                    </div>
                                    <div className="text-muted mt-1 px-1" style={{ fontSize: "10px" }}>
                                        <Moment format="hh:mm A">{message.created_at}</Moment>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "60vh" }}>
                            <RiMessage3Fill color="#c1486f" size={38} />
                            <div className="text-muted mt-2" style={{ fontSize: "14px" }}>Start Chatting Now</div>
                        </div>
                    )}
                    <div ref={this.chatEndRef} />
                </div>

                {/* Input Bar */}
                <div className="name-bar d-flex flex-row justify-content-between align-items-center w-100 px-3 py-2 text-muted position-fixed bottom-0 bg-white border-top shadow-lg">
                    <div className="flex-grow-1 me-2">
                        <input
                            onChange={(e) => this.handleMessageInput(e)}
                            onKeyDown={(e) => e.key === "Enter" && this.__sendChat()}
                            type="text"
                            className="form-control py-2 px-3"
                            value={this.state.message}
                            style={{
                                borderRadius: "24px",
                                backgroundColor: "#F8F9FA",
                                border: "1px solid #CED4DA",
                                fontSize: "14px",
                            }}
                            placeholder="Type a message..."
                        />
                    </div>
                    <button
                        onClick={this.__sendChat}
                        className="btn d-flex align-items-center justify-content-center"
                        style={{
                            backgroundColor: "#c1486f",
                            borderColor: "#c1486f",
                            borderRadius: "50%",
                            width: "42px",
                            height: "42px",
                            padding: "0",
                            boxShadow: "0 2px 6px rgba(193, 72, 111, 0.3)"
                        }}
                    >
                        <IoMdSend style={{ fontSize: "1.2rem", color: "#FFF" }} />
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.teacher.teacher,
    chats: state.teacherChat.chats,
    send_teacher_chat: state.teacherChat.send_teacher_chat,
});

export default connect(mapStateToProps, {
    getTeacherSingleChatView,
    sendTeacherChat,
    clearTeacherSingleChat,
})(SingleTeacherChat);
